import React from "react";
import { List, Item } from "./index.styled";
import { gsap } from "helpers/gsap";

const AnchorList = ({ data, active, color, className }) => {
  const { anchors } = data;
  const scrollToBlock = (blockId) => {
    gsap.to(window, {
      scrollTo: { y: blockId, offsetY: 0 },
      duration: 1,
    });
  };

  return (
    <List className={className}>
      {anchors.firstList?.map((item, index) => {
        return (
          <Item
            onClick={() => scrollToBlock(item.scrollToID)}
            $color={color}
            $active={active === item.text.toLowerCase()}
            key={`anchor-list-${index}`}
          >
            {item.text}
          </Item>
        );
      })}
    </List>
  );
};

export default AnchorList;
